<div class="container-noticias">
    <div class="width-paginate title-card" [style.background-color]="info?.facultad?.color">
        <h3 class="quicksand-bold">{{info.title}}</h3>
    </div>
    <div class="carousel-wrapper">
        <h2 class="width-paginate subtitle-noticias quicksand-bold">Noticias</h2>

        <!-- Flechas de navegación (Solo en Desktop) -->
        <div class="arrows" *ngIf="!isMobile && cards.length > cant">
            <button (click)="moveLeft()">
                <img class="arrow-carrousel" src="./assets/img/arrow-carrousel2-left.png" alt="Left Arrow">
            </button>
            <button (click)="moveRight()">
                <img class="arrow-carrousel" src="./assets/img/arrow-carrousel2-right.png" alt="Right Arrow">
            </button>
        </div>

        <!-- CARRUSEL -->
        <div class="carousel" #carouselWrapper (scroll)="onMobileScroll($event)" [attr.id]="componentId">
            <div #carouselContainer class="carousel-container" 
                 [ngStyle]="{ 
                    'transform': isMobile ? 'none' : carouselTransform,
                    'transition': isTransitioning && !isMobile ? 'transform 0.4s ease-in-out' : 'none'
                 }" 
                 (transitionend)="onTransitionEnd()">

                <div *ngFor="let item of cards" class="carousel-cell"> 
                    <a [href]="item.systemTitle || '#'" target="_blank" rel="noopener noreferrer" class="carrera-card">
                        <!-- Tag de Categoría -->
                        <div *ngIf="item.categoryTitle" class="card-badge quicksand-bold">{{ item.categoryTitle }}</div>

                        <!-- Imagen superior -->
                        <div class="card-img-container">
                            <img [src]="item.path" [alt]="item.title" class="card-bg-img" onerror="this.src='./assets/img/default.png'">
                        </div>

                        <!-- Cuerpo de la Tarjeta -->
                        <div class="card-body">
                            <h3 class="card-title quicksand-bold">{{ item.title }}</h3>
                            <p class="card-date">{{ item.date }}</p>
                            <p class="card-description nunito-medium">{{ item.summary }}</p>

                            <div class="card-btn nunito-bold zoomIn">LEER MÁS</div>
                        </div>
                    </a>
                </div>

            </div>
        </div>

        <div class="ver-mas zoomIn">
           <a [href]="url(info?.button_ver_mas)" target="_blank" rel="noopener noreferrer">
              <button class="quicksand-bold btn">VER TODAS LAS NOTICIAS</button>
           </a>
        </div>
    </div>
</div>